import Badge from "./ui/Badge";
import Card from "./ui/Card";
import PosterFrame from "./ui/PosterFrame";
import { BETA_ANALYTICS_EVENTS, trackBetaEvent } from "../utils/analytics";
import { listText, normalizeTags } from "../utils/showDisplay";
import { Link } from "react-router-dom";

export default function ShowCard({ show, rank = null, detailsTo = null }) {
  if (!show) return null;

  const tags = normalizeTags([...(show.genres || []).slice(0, 2), ...(show.moods || []).slice(0, 1)]);
  const pitch = show.pitch || {};
  const hook = pitch.hook || pitch.empress_hook || show.empress_hook;
  const cardProps = detailsTo
    ? {
        as: Link,
        to: detailsTo,
        state: { show },
        onClick: () =>
          trackBetaEvent(BETA_ANALYTICS_EVENTS.SHOW_CLICKED, {
            action: "view_details",
            show_id: show.id || show.show_id || null,
            surface: "show_card",
          }),
      }
    : {};

  return (
    <Card interactive className="block overflow-hidden p-3 no-underline" {...cardProps}>
      <div className="grid gap-4 sm:grid-cols-[130px_1fr]">
        <PosterFrame show={show} rank={rank} className="aspect-[2/3]" />
        <div className="min-w-0">
          <div className="mb-2 flex flex-wrap items-center gap-2">
            <Badge variant="gold">{show.platform || "Unknown"}</Badge>
            <Badge variant="neutral">{show.commitment_level || "Format not set"}</Badge>
          </div>
          <h3 className="font-display text-2xl font-bold leading-tight text-hookd-cream">
            {show.title || "Untitled"}
          </h3>
          <p className="mt-2 text-sm text-hookd-muted">{listText(show.genres, "Genres not set")}</p>
          {hook && <p className="mt-3 text-sm leading-6 text-hookd-cream">{hook}</p>}
          <div className="mt-4 flex flex-wrap gap-2">
            {tags.map((tag) => (
              <Badge key={tag}>{tag}</Badge>
            ))}
          </div>
          {detailsTo && (
            <span className="mt-4 inline-flex text-sm font-bold text-hookd-empress">
              View details →
            </span>
          )}
        </div>
      </div>
    </Card>
  );
}
